
import {
    Box, Text, Flex, Button,
} from "@chakra-ui/react"
import { ArrowDownIcon } from '@chakra-ui/icons'
import { motion } from "framer-motion";
import { AboutPage } from "./AboutPage"
import { ProjectsPage } from "./ProjectsPage"
import { ContactPage } from "./ContactPage"

type HomepageProps = {
    showNavbar : boolean,
    setShowNavbar: (showNavbar: boolean) => void 
}


export const Homepage = ({showNavbar, setShowNavbar} : HomepageProps) => {


    // const observer = new IntersectionObserver((entries) => {
    //     entries.forEach((entry) => {
    //         if (entry.isIntersecting) {
    //             entry.target.
    //         }
    //     })
    // })  
    // const hiddenElements = document.querySelectorAll('.hidden')
    // hiddenElements.forEach((el) => observer.observe(el))


    return (
        <Box width="100%" maxWidth="100%" height="100%" overflowX="hidden" bg="background">
            <Flex as={motion.div} onViewportLeave={() => {setShowNavbar(true)}} onViewportEnter={() => setShowNavbar(false)} id="HOME" width="100%" height="101vh" direction="column" justifyContent="center" alignItems="center" bg="web_bg">
                {/* Homepage */}
                <Box textStyle="body" fontSize="40px" p="3rem" textAlign="left" fontWeight="medium">
                    <Text as="span">Hi, I'm </Text>
                    <Text as="span" bgGradient="linear(to-l, #FF9820, #FFCA62)" bgClip="text">Ahmed. </Text>
                    <Text pb="3rem">A web developer.</Text>
                    <Button role="group" variant="special"
                        onClick={() => {
                            document.getElementById("ABOUT")?.scrollIntoView({ behavior: "smooth" })
                            setShowNavbar(true)
                        }}>
                        <Box pr="1.8rem"> LET'S GET <br /> STARTED </Box>
                        <ArrowDownIcon _groupHover={{ boxSize: "20" }} transition="0.25s" boxSize={16} />
                    </Button>
                </Box>
            </Flex>
            <AboutPage />
            <ProjectsPage />
            <ContactPage />
            <Box
                bg="container_bg"
                p="1rem" borderRadius="20px" margin="1rem auto" width="90%"
                border="solid 0.5px var(--chakra-colors-container_outline)"
                boxShadow="0px 0px 8px 0px var(--chakra-colors-container_shadow)">
                <Text variant="body" fontSize="14px"> &copy; 2024 Ahmed Imana - Portfolio</Text>
            </Box>


        </Box>

    )
}